/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes model module.
 * @module model/InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes
 * @version v0.3
 */
export default class InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes {
  /**
   * Constructs a new <code>InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes</code>.
   * @alias module:model/InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes} obj Optional instance to populate.
   * @return {module:model/InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes} The populated <code>InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('icd_code'))
        obj.icdCode = ApiClient.convertToType(data['icd_code'], 'String');
      if (data.hasOwnProperty('icd_code_id'))
        obj.icdCodeId = ApiClient.convertToType(data['icd_code_id'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes.prototype.id = undefined;

/**
 * @member {Number} position
 */
InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes.prototype.position = undefined;

/**
 * @member {String} icdCode
 */
InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes.prototype.icdCode = undefined;

/**
 * @member {String} icdCodeId
 */
InsuranceClaimsInsuranceClaimInsuranceClaimLineDiagnosesAttributes.prototype.icdCodeId = undefined;

